<template>
  <div class="select-wrap t_b-c">
    <div @click="showList">
      <p class="cur-label" :style="{color: color}">{{title}}</p>
      <i class="icon se-icon" :style="{borderColor: color}" :class="{active: status}"></i>
    </div>

    <transition name="list">
      <ul class="se-list t_btn-h-bc" v-show="status">
        <li class="se_item" v-for="(op, index) in options" :key="'option' + index" @click="selectItem(op)">
          {{op.label}}
        </li>
      </ul>
    </transition>
  </div>
</template>


<style scoped lang="stylus">
  .list-enter-active,.list-leave-active{
    opacity 1
    transform translateY(0) rotate(0) scale(1)
    transition all 0.2s ease-in-out
  }
  .list-enter,.list-leave-to{
    opacity 0
    transform translateY(-100%) rotate(90deg) scale(0)
  }
  .select-wrap {
    color #fff
    width 90px
    cursor pointer
    height 26px
    position relative
    font-size 14px
    line-height 26px
    border-radius 50px

    > div {
      padding 0 21px
      position relative
      box-sizing border-box

      .icon {
        top 50%
        right 12px
        display block
        margin-top -2px
        position absolute
        border-style solid;
        border-top-width 6px;
        border-left 6px solid transparent!important
        border-right 6px solid transparent!important
        border-bottom none
        transition all 0.2s linear
        &.active{
          transform rotate(180deg)
          opacity 0.5
        }
      }
    }

    .se-list {
      top 40px
      left 0
      width 100%
      position absolute
      box-sizing border-box
      border-width 1px
      border-style solid
      border-radius 4px
      background-color #ffffff
      z-index 1000
      min-width 140px

      &:before,&:after {
        left 50%
        content ""
        display block
        position absolute
        border-color transparent
        border-width 6px
        border-style solid
        border-bottom-color inherit
      }
      &:after{
        top -11px
        border-bottom-color #fff
      }
      &:before{
        top -12px
      }


      .se_item {
        color #666666
        text-align center
        border-bottom 1px solid #f0f0f0
        &:hover{
          color #333
          background-color rgba(240, 250, 230, 0.9)
        }
      }
      .se_item:last-child{
        border-bottom-right-radius 4px
        border-bottom-left-radius 4px
      }
    }
  }
</style>

<script>
  export default {
    name: "index",
    model: {
      prop: 'value',
      event: 'change'
    },
    props: {
      color: {
        type: String,
        default: '#ffffff'
      },
      value: {
        type: [Number, String],
        default: 0
      },
      options: {
        type: Array,
        default() {
          return [
            {
              label: 'sss',
              value: 0
            },
            {
              label: 'xxx',
              value: 1
            },
            {
              label: 'nnn',
              value: 2
            }
          ]
        }
      }
    },
    computed: {
      title() {
        return (this.options.find(i => i.value === this.value) || {}).label;
      }
    },
    methods: {
      showList() {
        this.status = !this.status;
      },
      selectItem(op) {
        if (op.label.indexOf('铃声')>=0 || op.label.indexOf('关闭')>=0){
            localStorage.setItem('sound', op.value);
        }
        
        this.$emit("change", op.value);
        this.status = false;
      }
    },
    mounted(){
      var sound = localStorage.getItem('sound') || 0;
      this.$emit("change", parseInt(sound));
      this.status = false;
    },
    data() {
      return {
        status: false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/c_select/index.vue